import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";
import type { ISubmitFeedback } from "@app/dashboard/types/innerLayout/submit-feedback";

export const submitFeedback = ({ rating, feedback }: ISubmitFeedback) => {
  const reqBody = {
    rating,
    comment: feedback,
  };
  
  return axiosPrivate.post(`/dashboard/v1/feedback`, { ...reqBody, source: "dashboard" });
};